module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.303c6d9e.ttf";